"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = ['cmyk', 'hex3', 'hex6', 'hsl', 'hsv', 'lab', 'pantone', 'ral', 'rgb', 'xyz', 'yuv'];